module.exports = __webpack_public_path__ + "img/spinner-dark.gif";